/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const useSeoContent = (
  pageType,
  itemId,
  options = { fallbackData: undefined }
) => {
  const key = `api/meta-data/${pageType}/${itemId}`;

  const {
    data: seoContent,
    isValidating,
    ...rest
  } = useFetch(
    itemId ? key : null,
    { hostType: HOST_TYPE.CMS }, // Preview mode will be handled automatically using the preview mode cookie.
    { fallbackData: options.fallbackData }
  );

  return {
    key,
    seoContent,
    isValidating,
    ...rest
  };
};

export default useSeoContent;
